import {mapProps} from 'recompose';

export const withSpreadProp = <TPropName extends string, TInner>(spreadProp: TPropName) =>
    mapProps<TInner, Record<TPropName, object>>(({[spreadProp]: spread, ...props}: any) => ({...props, ...spread}));
